import { get, patch, post, remove, put, cachedGet } from './base';
import { cacheKeys } from '@/helper/cache-keys';
export async function listPickups(storeId) {
    const res = (await get(`/stores/${storeId}/pickups`));
    return res.map((c) => ({
        ...c,
        date: new Date(Date.parse(c.date)),
    }));
}
export async function joinPickup(storeId, pickupDate) {
    const date = pickupDate.toISOString();
    return post(`/stores/${storeId}/pickups/${date}/users/current`);
}
export async function leavePickup(storeId, pickupDate, userId, message, sendKickMessage = true) {
    const date = pickupDate.toISOString();
    return remove(`/stores/${storeId}/pickups/${date}/users/${userId}`, {
        message,
        sendKickMessage,
    });
}
export async function leaveAllPickups(userId, message, sendKickMessage = false) {
    return remove(`users/${userId}/pickups`, {
        message,
        sendKickMessage,
    });
}
export async function confirmPickup(storeId, pickupDate, userId) {
    const date = pickupDate.toISOString();
    return patch(`/stores/${storeId}/pickups/${date}/users/${userId}`);
}
export async function checkPickupRuleStore(storeId, pickupDate) {
    const date = pickupDate.toISOString();
    const res = await get(`/stores/${storeId}/pickups/${date}/eligibility`);
    return res.isEligible;
}
export async function setPickupSlots(storeId, pickupDate, totalSlots, description) {
    const date = pickupDate.toISOString();
    return put(`/stores/${storeId}/pickups/${date}`, { totalSlots, description });
}
export async function listPickupHistory(storeId, fromDate, toDate) {
    const from = fromDate.toISOString();
    const to = toDate.toISOString();
    const slots = (await get(`/stores/${storeId}/pickups/history/${from}/${to}`));
    const slotsWithParsedDate = slots.map((s) => ({
        ...s,
        storeId,
        isConfirmed: !!s.confirmed,
        date: new Date(Date.parse(s.date)),
    }));
    return Object.groupBy(slotsWithParsedDate, (slot) => String(slot.date_ts));
}
export async function listSameDayAgendaForUser(fsId, onDate) {
    const day = onDate.toISOString();
    const res = (await get(`/users/${fsId}/agenda/${day}`));
    return res.map((p) => ({
        ...p,
        date: new Date(Date.parse(p.date)),
    }));
}
export async function listRegisteredPickups(fsId) {
    return await cachedGet(`/users/${fsId ?? 'current'}/pickups/registered`, {
        ...cacheKeys.listRegisteredPickups(fsId),
    });
}
export async function listPickupOptions({ force = false } = {}) {
    return await cachedGet('/users/current/pickups/options', {
        ...cacheKeys.listPickupOptions(),
        force,
    });
}
export async function listPastPickups(userId, limit, offset) {
    return await get(`/users/${userId}/pickups/history?limit=${limit}&offset=${offset}`);
}
export async function getRegularPickup(storeId) {
    return await get(`/stores/${storeId}/regular-pickups`);
}
export async function editRegularPickup(storeId, regularPickups) {
    return await put(`/stores/${storeId}/regular-pickups`, { regularPickups });
}
